export default {
  label: {
    fontSize: '16px',
    lineHeight: '18px',
    margin: '0 0 8px'
  }
}
